import React from "react";

export const ComputadorDesktopIcon = ({
  size = "32",
  className,
}: {
  size?: string;
  className?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={size}
      className={className}
      width={size}
    >
      <path d="m22.5 21h-21c-.827 0-1.5-.673-1.5-1.5v-14c0-.827.673-1.5 1.5-1.5h2c.276 0 .5.224.5.5s-.224.5-.5.5h-2c-.276 0-.5.224-.5.5v14c0 .276.224.5.5.5h21c.276 0 .5-.224.5-.5v-14c0-.276-.224-.5-.5-.5h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2c.827 0 1.5.673 1.5 1.5v14c0 .827-.673 1.5-1.5 1.5z" />
      <path d="m15.5 24h-7c-.202 0-.385-.122-.462-.309-.078-.187-.035-.402.108-.545 1.316-1.316 1.333-2.59 1.333-2.644.001-.275.225-.502.501-.502h4.02c.275 0 .499.222.5.497.001.063.04 1.336 1.354 2.649.143.143.186.358.108.545-.077.187-.26.309-.462.309zm-5.929-1h4.857c-.56-.801-.782-1.537-.87-2h-3.13c-.085.465-.301 1.2-.857 2zm4.929-2.5h.01z" />
      <path d="m23.5 18h-23c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h23c.276 0 .5.224.5.5s-.224.5-.5.5z" />
      <path d="m12.5 12h-1c-.827 0-1.5-.673-1.5-1.5v-2.5h-2.5c-.827 0-1.5-.673-1.5-1.5v-1c0-.827.673-1.5 1.5-1.5h2.5v-2.5c0-.827.673-1.5 1.5-1.5h1c.827 0 1.5.673 1.5 1.5v2.5h2.5c.827 0 1.5.673 1.5 1.5v1c0 .827-.673 1.5-1.5 1.5h-2.5v2.5c0 .827-.673 1.5-1.5 1.5zm-5-7c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5h3c.276 0 .5.224.5.5v3c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5v-3c0-.276.224-.5.5-.5h3c.276 0 .5-.224.5-.5v-1c0-.276-.224-.5-.5-.5h-3c-.276 0-.5-.224-.5-.5v-3c0-.276-.224-.5-.5-.5h-1c-.276 0-.5.224-.5.5v3c0 .276-.224.5-.5.5z" />
    </svg>
  );
};
